import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  IVehicle, IVehicleCreatePayload, IVehicleUpdatePayload,
  IVehicleDefectCheck,
  IVehicleDefect,
  IMileageLog, IMileageLogCreatePayload,
} from "../../../types/api/vehicle";

export async function listVehicles(params: any): Promise<AxiosResponse<TResponseWithQData<IVehicle[]>>> {
  return axios.get(API_ENDPOINTS.VEHICLE_LIST, { params });
}
export async function vehicleDetail(id: number): Promise<AxiosResponse<TResponse<IVehicle>>> {
  return axios.get(`${API_ENDPOINTS.VEHICLE_DETAIL}/${id}`);
}
export async function createVehicle(data: IVehicleCreatePayload): Promise<AxiosResponse<TResponse<IVehicle>>> {
  return axios.post<TResponse<IVehicle>>(API_ENDPOINTS.VEHICLE_CREATE, data);
}
export async function updateVehicle(data: IVehicleUpdatePayload): Promise<AxiosResponse<TResponse<IVehicle>>> {
  return axios.post<TResponse<IVehicle>>(API_ENDPOINTS.VEHICLE_UPDATE, data);
}
export async function deleteVehicle(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.VEHICLE_DELETE, { id });
}

export async function listDefectChecks(vehicle_id: number, params?: any): Promise<AxiosResponse<TResponseWithQData<IVehicleDefectCheck[]>>> {
  return axios.get(`/vehicles/${vehicle_id}/defect-checks`, { params });
}

export async function listDefects(params: any): Promise<AxiosResponse<TResponseWithQData<IVehicleDefect[]>>> {
  return axios.get(API_ENDPOINTS.VEHICLE_DEFECTS_LIST, { params });
}
export async function resolveDefect(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.VEHICLE_DEFECT_RESOLVE, { id });
}

export async function listMileageLogs(params: any): Promise<AxiosResponse<TResponseWithQData<IMileageLog[]>>> {
  return axios.get(API_ENDPOINTS.VEHICLE_MILEAGE_LIST, { params });
}
export async function createMileageLog(data: IMileageLogCreatePayload): Promise<AxiosResponse<TResponse<IMileageLog>>> {
  return axios.post<TResponse<IMileageLog>>(API_ENDPOINTS.VEHICLE_MILEAGE_CREATE, data);
}
